// extracted by mini-css-extract-plugin
module.exports = {"collection":"Collection_collection__1AxyD","locus":"Collection_locus__2K5Td"};